import React from "react";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import AuthPage from "./components/AuthPage/AuthPage";
import UserPortalPage from "./components/UserPortal/UserPortalPage";
import OwnerPortalPage from "./components/OwnerPortal/OwnerPortalPage";
import ResetPasswordPage from "./components/ResetPasswordPage/ResetPasswordPage";
import UserProfile from "./components/UserProfile/UserProfile";
import TrusteePortalPage from "./components/TrusteePortal/TrusteePortalPage";
import AccountDetailView from "./components/AccountDetailPage/AccountDetailPage";
import LevyAccountDetailPage from "./components/LevyAccountDetailPage/LevyAccountDetailPage";
import FRChangePage from "./components/FRChangePage/FRChangePage";
import DownloadStatementPage from "./components/DownloadStatementPage/DownloadStatementPage";
import BuildingApprovalDetailPage from "./components/BuildingApprovalPage/BuildingApprovalPage";
import BuildingInfoPage from "./components/BuildingInfoPage/BuildingInfoPage";
import BuildingOwnerInfoPage from "./components/BuildingOwnerInfo/BuildingOwnerInfoPage";

import AODDetailPage from "./components/AODViewPage/AODViewPage";
import LegalDetailPage from "./components/LegalViewPage/LegalViewPage";
import PaymentDetailPage from "./components/PaymentViewPage/PaymentViewPage";
import MaintenanceDetailPage from "./components/MaintenanceViewPage/MaintenanceViewPage";
import ContractorDetailPage from "./components/ContractorViewPage/ContractorViewPage";
import TaskDetailPage from "./components/TaskViewPage/TaskViewPage";
import LevyAccountViewPage from "./components/LevyAccountViewPage/LevyAccountViewPage";
import LoggedTicketViewPage from "./components/LoggedTicketViewPage/LoggedTicketViewPage";
import ChangePasswordPage from "./components/ChangePasswordPage/ChangePasswordPage";
import TrusteeAccViewPage from "./components/TrusteeAccountViewPage/TrusteeAccViewPage";
import ContractorPortalPage from "./components/ContractorPortalPage/ContractorPortalPAge";
import ContractorLegalViewPage from "./components/ContractorLegalViewPage/ContractorLegalViewPage";
import ContractorMaintViewPage from "./components/ContractorMaintViewPage/ContractorMaintViewPage";
import ContractorRegPage from "./components/ContractorRegPage/ContractorRegPage";
import ContractorAccountLedgerPage from "./components/ContractorAccountLedgerPage/ContractorAccountLedgerPage";
import RentalPortalPage from "./components/RentalsPortal/RentalPortal";
import RentalUnitViewPage from "./components/RentalUnitViewPage/RentalUnitViewPage";

// Private Route Component
const PrivateRoute = ({ element }) => {
  const token = localStorage.getItem("token");
  return token ? element : <Navigate to="/" />;
};

function App() {
  return (
    <HashRouter>
      <Routes>
        {/* Public Routes */}
        {/* <Route path="/gma-quote-request" element={<RequestAGMAQuote />} />*/}
        {/*<Route path="/contact-us" element={<ContactUs />} />*/}
        {/*<Route path="/rental-request" element={<RentalRequest />} />*/}
        {/*<Route path="/rental-unit-request" element={<RentalUnitRequest />} />*/}
        <Route path="/" element={<AuthPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/change-password" element={<ChangePasswordPage />} />
        <Route
          path="/contractor-registration"
          element={<ContractorRegPage />}
        />

        {/* Private Routes */}
        <Route
          path="/user-portal"
          element={<PrivateRoute element={<UserPortalPage />} />}
        />
        <Route
          path="/owner-portal"
          element={<PrivateRoute element={<OwnerPortalPage />} />}
        />
        <Route
          path="/user-profile"
          element={<PrivateRoute element={<UserProfile />} />}
        />
        <Route
          path="/trustee-portal"
          element={<PrivateRoute element={<TrusteePortalPage />} />}
        />
        <Route
          path="/account-detail-view/:accountId"
          element={<PrivateRoute element={<AccountDetailView />} />}
        />
        <Route
          path="/levy-account-detail/:levyAccountId/:responsiblePersonId"
          element={<PrivateRoute element={<LevyAccountDetailPage />} />}
        />
        <Route
          path="/fr-change"
          element={<PrivateRoute element={<FRChangePage />} />}
        />
        <Route
          path="/download-statement"
          element={<PrivateRoute element={<DownloadStatementPage />} />}
        />
        <Route
          path="/building-approvals/:approvalId"
          element={<PrivateRoute element={<BuildingApprovalDetailPage />} />}
        />
        <Route
          path="/building-info/:building_guid"
          element={<BuildingInfoPage />}
        />
        <Route
          path="/building-owner-info/:building_guid"
          element={<BuildingOwnerInfoPage />}
        />
        <Route
          path="/aod/:id/:buildingId"
          element={<PrivateRoute element={<AODDetailPage />} />}
        />
        <Route
          path="/legal/:id/:buildingId"
          element={<PrivateRoute element={<LegalDetailPage />} />}
        />
        <Route
          path="/payment/:id/:buildingId"
          element={<PrivateRoute element={<PaymentDetailPage />} />}
        />
        <Route
          path="/maintenance/:id/:buildingId"
          element={<PrivateRoute element={<MaintenanceDetailPage />} />}
        />
        <Route
          path="/contractor/:id/:buildingId"
          element={<PrivateRoute element={<ContractorDetailPage />} />}
        />
        <Route
          path="/task/:id/:buildingId"
          element={<PrivateRoute element={<TaskDetailPage />} />}
        />
        <Route
          path="/levyaccount/:accountId/:buildingId"
          element={<PrivateRoute element={<LevyAccountViewPage />} />}
        />
        <Route
          path="/loggedticket/:ticketId"
          element={<PrivateRoute element={<LoggedTicketViewPage />} />}
        />
        <Route
          path="/trustee-account/:accountId/:buildingId"
          element={<PrivateRoute element={<TrusteeAccViewPage />} />}
        />
        <Route
          path="/contractor-portal"
          element={<PrivateRoute element={<ContractorPortalPage />} />}
        />
        <Route
          path="/contractor-maint/:id/:contractorId"
          element={<PrivateRoute element={<ContractorMaintViewPage />} />}
        />
        <Route
          path="/contractor-legal/:id/:contractorId"
          element={<PrivateRoute element={<ContractorLegalViewPage />} />}
        />
        <Route
          path="/contractor-accounts/:contractorId/:buildingId"
          element={<ContractorAccountLedgerPage />}
        />
        <Route
          path="/rental-portal"
          element={<PrivateRoute element={<RentalPortalPage />} />}
        />
        <Route
          path="/rental-unit/:rentalUnitId"
          element={<RentalUnitViewPage />}
        />
      </Routes>
    </HashRouter>
  );
}

export default App;
